import React from "react";
// Components
// import FullButton from "../Buttons/FullButton";
// Assets
import HeaderImage from "../../assets/img/xhosha-bagger.jpg";
// import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

export default function Header() {
  return (
    <section id="home" className="pt-20 w-full min-h-[640px] md:min-h-[840px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8 items-center">
        <div className="flex justify-center md:justify-start order-2 md:order-none">
          <div>
            <h1 className="font-extrabold text-2xl md:text-3xl lg:text-4xl">Ihr Partner in München und Umland bei Erdbewegungen aller Art</h1>
            <div className="mt-4 md:mt-6 max-w-xl text-sm md:text-base font-semibold leading-6">
              Grabungen wie bei Kanalarbeiten, Wasserleitungen, Kinetten für Verkabelungen sind nach 15 Jahren Erfahrung Standard für uns.
              Aber wir sind auch für Sie da wenn es über Standards hinausgeht!
              Ein Team von 10 qualifizierten und erfahrenen Mitarbeitern kümmern sich um sämtliche Anforderungen zahlreicher Kunden. Die wichtigsten Kernpunkte aller Tätigkeiten im Dienste des Kunden sind persönliche Beratung, Zuverlässigkeit, Flexibilität, Pünktlichkeit und Sicherheit.
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="flex justify-end md:justify-center relative z-10">
            <img className="rounded-lg w-full md:w-4/5" src={HeaderImage} alt="office" />
          </div>
          <div className="absolute right-0 top-0 h-[500px] w-1/3 bg-gray-100 hidden md:block" aria-hidden="true"></div>
          <div className="absolute -right-24 md:right-24 bottom-24 hidden md:block">
            <Dots />
          </div>
        </div>
      </div>
    </section>
  );
}



